require('./RAEmailRequiredWarning.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @commons
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const { OKLink } = require('commonsComponents/OKLink');
const OKModal = require('commonsComponents/OKModal');
const { OKButton } = require('commonsComponents/OKButton');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constants
const { MYPROFILE_BROKER_ROBO_URL } = require('../../../raConstants/index');

class RAEmailRequiredWarning extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: !this.props.email,
        };
        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    handleToggleModal() {
        this.setState({
            showModal: false,
        });
        this.props.history.push(MYPROFILE_BROKER_ROBO_URL);
    }

    render() {
        const { clientName } = this.props;
        const modalBody = (
            <div className="ra-email-required-warning">
                <BlockInfo extraClass="ra-email-required-warning__block-info">
                    <FormattedText
                        className="ra-email-required-warning__block-info-title"
                        value="raEmailRequiredWarning-raEmailRequiredWarning_legalTextTitle"
                    />
                    <FormattedText
                        className="ra-email-required-warning__block-info-text"
                        value="raEmailRequiredWarning-raEmailRequiredWarning_legalText1"
                        injectedStrings={[clientName]}
                    />
                    <FormattedText
                        className="ra-email-required-warning__block-info-text"
                        value="raEmailRequiredWarning-raEmailRequiredWarning_legalText2"
                        injectedStrings={[clientName]}
                    />
                </BlockInfo>
                <div className="ra-email-required-warning__footer clearfix">
                    <span className="pull-left">
                        <OKButton
                            modifier="link-ghost"
                            onClick={this.handleToggleModal}
                        >
                            <FormattedText value="raEmailRequiredWarning-raEmailRequiredWarning_leftButtonText" />
                        </OKButton>
                    </span>
                    <span className="pull-right ra-email-required-warning__footer-link">
                        <OKLink
                            to="myprofile/edit"
                            modifier="complementary"
                            inverse={false}
                        >
                            <FormattedText value="raEmailRequiredWarning-raEmailRequiredWarning_rightButtonText" />
                        </OKLink>
                    </span>
                </div>
            </div>
        );

        return (
            <ContactCenterRender>
                <OKModal
                    content={modalBody}
                    isOpen={this.state.showModal}
                    onCloseCallback={this.handleToggleModal}
                    size="extra-large"
                />
            </ContactCenterRender>
        );
    }
}

RAEmailRequiredWarning.propTypes = {
    history: PropTypes.object.isRequired,
    clientName: PropTypes.string.isRequired,
    email: PropTypes.string,
};

module.exports = withRouter(RAEmailRequiredWarning);
